module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/onjCDzaGp6HlL4YdRGQ83-0b2032f72465b676b966b75e0aaf4365.jpg";